import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import useRegistryRoutes from './useRegistryRoutes';

export default function useIsRegistryRoute(path = '') {
  const pathname = usePathname();
  const registryRoutes = useRegistryRoutes();
  const currentPath = path || pathname;

  const isRegistryRoute = useMemo(
    () =>
      Object.values(registryRoutes).some((route) =>
        currentPath.includes(route),
      ),
    [currentPath, registryRoutes],
  );

  return isRegistryRoute;
}
